import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'

var v = {
	'items-xl': 5,
	'items-lg': 3,
	'items-md': 2,
	'items-sm': 1,
	'items-xs': 1,
	navigation: false,
	pagination: true,
	loop: false,
	autoplay: false,
	autoplayTimeout: 5000,
	center: false,
	'row-height': false
}

function getData($element, data) {
	var value = $element.data(data)
	return value === undefined ? v[data] : value
}
$(document).ready(function() {
	$('.product-slider .owl-item')
		.on('mouseenter', function(i) {
			$(this).css('z-index', 1000)
		})
		.on('mouseleave', function(i) {
			$(this).css('z-index', 1)
		})
	$('.news-carousel').owlCarousel({
		navContainer: 'custom-nav'
	})
})

jQuery('[data-plugin=carousel]').each(function() {
	var $element = $(this),
		itemsXl = getData($element, 'items-xl'),
		itemsLg = getData($element, 'items-lg'),
		itemsMd = getData($element, 'items-md'),
		itemsSm = getData($element, 'items-sm'),
		itemsXs = getData($element, 'items-xs'),
		navigation = getData($element, 'navigation'),
		pagination = getData($element, 'pagination'),
		stagePadding = getData($element, 'stagepadding'),
		navContainer = getData($element, 'navContainer'),
		loop = getData($element, 'loop'),
		autoplay = getData($element, 'autoplay'),
		autoplayTimeout = getData($element, 'autoplay-timeout'),
		center = getData($element, 'center'),
		rowHeight = getData($element, 'row-height')

	$element.addClass('owl-carousel owl-theme')

	$element.owlCarousel({
		center: center,
		autoWidth: false,
		autoHeight: false,
		responsiveClass: true,
		lazyLoad: false,
		loop: loop,
		autoplaySpeed: 500,
		autoplay: autoplay,
		autoplayHoverPause: autoplay,
		autoplayTimeout: autoplayTimeout,

		navText: [
			'<button class="carousel-btn news-prev"><img src="/assets/images/svg/arrow_left_red.svg" alt=""></button>',
			'<button class="carousel-btn news-next"><img src="/assets/images/svg/arrow_right_red.svg" alt=""></button>'
		],
		dots: pagination,
		nav: navigation,
		responsive: {
			0: {
				items: itemsXs
			},
			576: {
				items: itemsSm
			},
			768: {
				items: itemsMd,
				stagePadding: stagePadding
			},
			992: {
				items: itemsLg,
				stagePadding: stagePadding
			},
			1200: {
				items: itemsXl,
				stagePadding: stagePadding
			}
		},
		onInitialized: function() {
			$element.addClass('owl-init')
		}
	})
})

//    checkClasses();
//     carousel.on('translated.owl.carousel', function(event) {
//         checkClasses();
//     });

//     function checkClasses(){
//         var total = $('.latest-work-carousel .owl-stage .owl-item.active').length;

//         $('.latest-work-carousel .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');

//         $('.latest-work-carousel .owl-stage .owl-item.active').each(function(index){
//             if (index === 0) {
//                 // this is the first one
//                 $(this).addClass('firstActiveItem');
//             }
//             if (index === total - 1 && total>1) {
//                 // this is the last one
//                 $(this).addClass('lastActiveItem');
//             }
//         });
//     }



// WEBPACK FOOTER //
// ./public/assets/app/plugins/carousel.js